<template>
  <img
    :src="iconContent"
    :alt="iconAlt"
    :width="width"
    :height="height"
    :style="iconStyle"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SvgIcon",
  props: {
    iconContent: {
      type: String,
      default: "",
    },
    iconAlt: {
      type: String,
      default: "",
    },
    iconStyle: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 25,
    },
    height: {
      type: Number,
      default: 25,
    },
  },
});
</script>
